/**
 * 
 * key
 * 
 */


const key = 'Y3JtV2lzZVByb2R1Y3RTdGF0dXNSZXBvcnQ='

export default key 